<template>
  <el-cascader
      :style="cssVariables"
      class="deptCascadeSelect"
      ref="cascadeSelect"
      v-model="values"
      :title="checkedLabel"
      :options="options"
      :props="{ multiple: true, checkStrictly: true, emitPath: false, value: 'id', label: 'name' }"
      clearable
      filterable
      collapse-tags
      :show-all-levels="false"
      size="mini"
      @change="handleChange">
  </el-cascader>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
import { fetchTree } from '@/api/admin/dept'
import { deepClone, getParamString } from '@/tdcommon/beeutil'

export default {
  // 部门级联查询 多选 支持搜索 仅显示选择的最后一级
  name: 'd2-container-dept-cascadeSelect',
  data () {
    return {
      values: [],
      options: [],
      checkedLabel: '',
      loading: false
    }
  },
  props: {
    inputWidth: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    cssVariables () {
      return {
        '--input-width': this.inputWidth + 'px'
      }
    }
  },
  methods: {
    remoteMethod () {
      this.loading = true
      fetchTree().then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = validatenull(response.data) ? [] : this.filterEmptyChildren(response.data[0].children)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 过滤掉最后一级的空children
    filterEmptyChildren (data) {
      // 深拷贝数据，避免修改原始数据
      const cloneData = deepClone(data)

      // 递归处理每个节点
      function processNode (node) {
        // 如果节点有children且children数组为空，则删除children属性
        if (node.children && Array.isArray(node.children) && node.children.length === 0) {
          delete node.children
        }
        // 如果节点有children且children不为空，则递归处理每个子节点
        else if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          node.children.forEach(child => processNode(child))
        }
      }

      // 处理根节点数组中的每个节点
      cloneData.forEach(node => processNode(node))

      return cloneData
    },
    handleChange (val) {
      // let changeValues = validatenull(val) ? [] : val
      // this.$emit('change', val)

      let checkedLabel = validatenull(this.$refs.cascadeSelect.getCheckedNodes()) ? '' : getParamString(this.$refs.cascadeSelect.getCheckedNodes(), 'label')
      this.checkedLabel = checkedLabel
    }
  },
  watch: {
    values: function (val, oldVal) {
      if (val !== oldVal) {
        let changeValues = validatenull(val) ? [] : val
        this.$emit('input', changeValues)
      }
    }
  },
  mounted () {
    this.remoteMethod()
  }
}
</script>

<style lang="scss" scoped>
.deptCascadeSelect {
  ::v-deep .el-cascader__search-input {
    font-size: 12px;
    margin: 0 0 0 15px;
    min-width: 1px;
    padding: 0;
  }
  ::v-deep .el-cascader__tags .el-tag>span {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .el-cascader__tags {
    max-width: calc(var(--input-width) - 32px);
    width: 100%;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-dept-cascadeSelect/index.vue"
}
</vue-filename-injector>
